import React from "react";
import "./showMore.scss";

interface Props {
  className?: string;
  text: string;
  maxLength?: number;
  expanderLink?: boolean;
}

interface LocalState {
  open: boolean;
}

export class ShowMore extends React.Component<Props, LocalState> {

  constructor(props: Props) {
    super(props);
    this.state = {open: false}
  }

  static defaultProps = {
    maxLength: 200,
    enableExpander: true,
  }

  private toggleOpen(){
    var open = this.state.open;
    this.setState({open: !open});
  }

  render(){
    var expanderLink = this.props.expanderLink;
    var maxLength = this.props.maxLength;
    var length = this.props.text.length;

    return (
      <div className="show-more">
        <p>{this.state.open && this.props.text || this.props.text.substring(0,maxLength)}

        {length > maxLength && expanderLink && (
          <span className={"clickable"} onClick={e => this.toggleOpen()}>... <a>{this.state.open && 'show less' || 'show more'}</a></span>
        ) || ("...")}
        </p>

      </div>
    );
  }

}
